import ChevronLeftIcon from 'components/material-symbol/icons/ChevronLeft'
import ChevronRightIcon from 'components/material-symbol/icons/ChevronRight'
import ExpandMoreIcon from 'components/material-symbol/icons/ExpandMore'

const calendarHeaderIconProps = {
  fontSize: 'small',
  opticalSize: 20,
}

export const calendarDateCalendarSlots = {
  leftArrowIcon: ChevronLeftIcon,
  rightArrowIcon: ChevronRightIcon,
  switchViewIcon: ExpandMoreIcon,
}

export const calendarDateCalendarSlotProps = {
  leftArrowIcon: calendarHeaderIconProps,
  rightArrowIcon: calendarHeaderIconProps,
  switchViewIcon: calendarHeaderIconProps,
}
